import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../../data/mock';

const TestimonialsSection = () => {
  return (
    <section className="bg-black py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-[#00FFD1] text-sm font-medium tracking-wide uppercase mb-4">
            Client Testimonials
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-tight mb-6">
            Trusted by Florida Businesses
          </h2>
          <p className="text-lg text-white/70 leading-relaxed">
            See what our clients say about our armed security services.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="group bg-[#121212] border border-white/10 hover:border-[#00FFD1]/30 p-8 transition-all duration-400"
            >
              <Quote className="w-10 h-10 text-[#00FFD1]/30 mb-6" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#00FFD1] text-[#00FFD1]" />
                ))}
              </div>
              
              {/* Content */}
              <p className="text-white/85 text-lg leading-relaxed mb-6">
                "{testimonial.content}"
              </p>
              
              {/* Author */}
              <div className="pt-6 border-t border-white/10">
                <p className="text-white font-semibold">{testimonial.name}</p>
                <p className="text-white/60 text-sm">{testimonial.role}</p>
                <p className="text-[#00FFD1] text-sm">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <p className="text-center text-white/40 text-sm mt-12">
          * Testimonials shown are representative examples. Actual client details may vary.
        </p>
      </div>
    </section>
  );
};

export default TestimonialsSection;
